import Divider from '@material-ui/core/Divider'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormHelperText from '@material-ui/core/FormHelperText'
import FormLabel from '@material-ui/core/FormLabel'
import Grid from '@material-ui/core/Grid'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import Select from '@material-ui/core/Select'
import TextField from '@material-ui/core/TextField'
import makeStyles from '@material-ui/core/styles/makeStyles'
import React, { useState, useEffect } from 'react'

import { energy as energyUtils, errors as errorUtils } from '../../../../../../utils'
import { FormControl } from '../../../../../../components/Forms'
import { appService, energyService } from '../../../../../../services'

const useStyles = makeStyles(() => ({
  divider: {
    margin: '20px 0',
  },
  questionLabel: {
    fontWeight: 500,
    marginBottom: '4px',
  },
}))

const EnergySection = ({ address, errors, validating, update }) => {
  const classes = useStyles()
  const [operators, setOperators] = useState([])

  const hasError = errorUtils.hasError(errors)
  const errorMessage = errorUtils.errorMessage(errors)

  const { requestEnergyBillData, energyCodeType } = appService.getLocalPublicCall()
  const showConsumerUnitNumber = energyUtils.showsConsumerUnitNumber(energyCodeType)
  const showInstallationCode = energyUtils.showsInstallationCode(energyCodeType)

  useEffect(() => {
    if (!requestEnergyBillData) return

    if (address.servedByElectricity !== true) return
    const fetchOperators = async () => {
      const { payload: { operators: ops } } = await energyService.getAll()
      setOperators(ops)
    }
    fetchOperators()
  }, [address.servedByElectricity])

  const attendedValue = () => {
    if (address.servedByElectricity === true) return 'true'
    if (address.servedByElectricity === false) return 'false'
    return ''
  }

  if (!requestEnergyBillData) return null

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Divider className={classes.divider} />
      </Grid>

      <Grid item xs={12}>
        <FormControl error={hasError('servedByElectricity')}>
          <FormLabel component="legend" className={classes.questionLabel}>
            Aluno é atendido por operadora de energia elétrica? *
          </FormLabel>
          <RadioGroup
            row
            name="servedByElectricity"
            value={attendedValue()}
            onChange={e => {
              const attended = e.target.value === 'true'
              update({
                servedByElectricity: attended,
                ...(!attended && {
                  electricalPowerOperatorId: undefined,
                  consumerUnitNumber: undefined,
                  electricityInstallationCode: undefined,
                }),
              })
            }}
          >
            <FormControlLabel
              disabled={validating}
              value="true"
              control={<Radio color="primary" />}
              label="Sim"
            />
            <FormControlLabel
              disabled={validating}
              value="false"
              control={<Radio color="primary" />}
              label="Não"
            />
          </RadioGroup>
          {hasError('servedByElectricity') && (
            <FormHelperText>{errorMessage('servedByElectricity')}</FormHelperText>
          )}
        </FormControl>
      </Grid>

      {address.servedByElectricity === true && (
        <>
          <Grid item xs={12} md={6}>
            <FormControl variant="outlined" error={hasError('electricalPowerOperatorId')}>
              <InputLabel htmlFor="electricalPowerOperatorId">
                Operador de Energia Elétrica *
              </InputLabel>
              <Select
                disabled={validating}
                id="electricalPowerOperatorId"
                label="Operador de Energia Elétrica *"
                value={address.electricalPowerOperatorId || ''}
                onChange={e => update({ electricalPowerOperatorId: e.target.value })}
              >
                {operators.map(op => (
                  <MenuItem key={op.value} value={op.value}>
                    {op.label}
                  </MenuItem>
                ))}
              </Select>
              {hasError('electricalPowerOperatorId') && (
                <FormHelperText>{errorMessage('electricalPowerOperatorId')}</FormHelperText>
              )}
            </FormControl>
          </Grid>

          {requestEnergyBillData && showConsumerUnitNumber && (
            <Grid item xs={12} md={6}>
              <FormControl>
                <TextField
                  error={hasError('consumerUnitNumber')}
                  helperText={errorMessage('consumerUnitNumber')}
                  disabled={validating}
                  label="Nº da Unidade Consumidora *"
                  variant="outlined"
                  name="consumerUnitNumber"
                  value={address.consumerUnitNumber || ''}
                  onChange={e => update({ consumerUnitNumber: e.target.value })}
                />
              </FormControl>
            </Grid>
          )}

          {requestEnergyBillData && showInstallationCode && (
            <Grid item xs={12} md={6}>
              <FormControl>
                <TextField
                  error={hasError('electricityInstallationCode')}
                  helperText={errorMessage('electricityInstallationCode')}
                  disabled={validating}
                  label="Código de instalação elétrica (antigo) *"
                  variant="outlined"
                  name="electricityInstallationCode"
                  value={address.electricityInstallationCode || ''}
                  onChange={e => update({ electricityInstallationCode: e.target.value })}
                />
              </FormControl>
            </Grid>
          )}
        </>
      )}
    </Grid>
  )
}

export default EnergySection
